import React from 'react';

const Survey = () => {
  return (
    <div className="container py-5">
      <h1>Опрос</h1>
      <p>Поделитесь своим мнением, заполнив наш опрос.</p>
    </div>
  );
};

export default Survey;